module.exports = __webpack_public_path__ + "static/media/ruth.673034f2.png";